import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, formatApiErrorDetail } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [error, setError] = useState('');

  const checkSession = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = useCallback(async (username, password) => {
    setError('');
    try {
      const { data } = await api.post('/auth/login', { username, password });
      if (data.access_token) localStorage.setItem('access_token', data.access_token);
      setUser({ id: data.id, username: data.username, name: data.name, role: data.role });
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || 'Kirjautuminen epäonnistui');
      return false;
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post('/auth/logout');
    } catch {}
    localStorage.removeItem('access_token');
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, error, setError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
